import { colorsPalettes } from "@similarweb/styles";
import styled, { css } from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { SWReactIcons } from "@similarweb/icons";
import { Button } from "@similarweb/ui-components";

export const TRIAL_BANNER_HEIGHT = 54;
export const getTrialBannerHeight = (isTrial: boolean): number => (isTrial ? TRIAL_BANNER_HEIGHT : 0);

export interface IBaseBannerTheme {
    color: string;
    background: string;
    ctaButtonColor?: string;
}

export interface IBannerTheme extends IBaseBannerTheme {
    counterColor: string;
}

export const trialBannerTheme: IBaseBannerTheme = {
    color: colorsPalettes.carbon[0],
    background: colorsPalettes.indigo[300],
    ctaButtonColor: colorsPalettes.indigo[300],
};

export const TrialBannerContent = styled(FlexRow)<{
    isSticky: boolean;
    justify: string;
}>`
    position: relative;
    z-index: 3;
    align-items: center;
    justify-content: ${({ justify }) => justify};
    min-height: ${TRIAL_BANNER_HEIGHT}px;
    font-size: 1rem;
    padding: 0 24px;
    color: ${trialBannerTheme.color};
    background: ${trialBannerTheme.background};
    ${({ isSticky }) =>
        isSticky &&
        css`
            position: sticky;
            top: 0;
        `};

    ${SWReactIcons} {
        path {
            fill: ${trialBannerTheme.color};
        }
    }
`;

export const BackButton = styled(Button)`
    border-width: 2px;
    border-color: #fff;
    font-size: 0.875rem;
    font-weight: 700;

    &:hover {
        border-width: 2px;
        border-color: #fff;
    }

    & > * {
        font-family: "DM Sans", sans-serif !important;
        color: #fff !important;

        &:hover {
            color: #d7d7d7 !important;
        }
    }
`;
